import React from "react"
import Img from "gatsby-image"
import YouTube from "react-youtube"

const ListPointMedia = ({ media }) => {

  const isYouTube = () => {
    if (media.url && media.url.includes("youtube")) {
      return true;
    }    
  }

  const isImage = () => {
    if (media.childImageSharp && media.childImageSharp.fluid) {
      return true;
    }
  }

  if (isYouTube()) {
    var videoId = media.url.split("v=")[1]
    var ampersandPosition = videoId.indexOf("&")
    if (ampersandPosition !== -1) {
      videoId = videoId.substring(0, ampersandPosition)
    }

    const opts = {
      height: "300",
      width: "530",
    }

    return <YouTube videoId={videoId} opts={opts} />
  } else if (isImage()) {
    return (
      <Img
        style={{ marginBottom: "20px" }}
        fluid={media.childImageSharp.fluid}
      />
    )
  } else {
    return <p></p>
  }
}

export default ListPointMedia
